import {
    CONFIRMED_GET_PROERTY_TYPES
} from '../actions/propertyType/PropertyTypeTypes';
const initialState = {
    PropertyTypes: [],
    loading: false,
};

function PropertyTypesReducer(state = initialState, actions) {
    switch (actions.type) {
        case 'SET_PROPERTY_TYPES_LOADING':
            return {
                ...state,
                loading: actions.payload,
            };
        case CONFIRMED_GET_PROERTY_TYPES:
            return {
                ...state,
                PropertyTypes: actions.payload,
                loading: false,
            };
        default:
            return state;
    }
}

export {PropertyTypesReducer};